var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-menu',{attrs:{"offset-y":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({},'div',attrs,false),on),[_vm._t("default")],2)]}}],null,true)},[_c('v-card',{staticClass:"d-flex flex-column px-3 pt-3"},[_c('vote-log',{attrs:{"reference":_vm.reference,"full-text-review":_vm.fullTextReview}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }